import { TFunction } from 'i18next';

export const AGENT_CHAT_SUGGESTION_KEYS = [
	'aiAgent.suggestions.yearSummary',
	'aiAgent.suggestions.goals',
	'aiAgent.suggestions.feedback',
] as const;

export type AgentChatSuggestionKey = (typeof AGENT_CHAT_SUGGESTION_KEYS)[number];

export type MatchedAgentChatSuggestion = {
	key: AgentChatSuggestionKey;
	isMe: boolean;
	name?: string;
};

function matchesTranslation(
	message: string,
	template: string,
): Omit<MatchedAgentChatSuggestion, 'key'> | undefined {
	if (!template.includes('{{name}}') && template === message) {
		return { isMe: true };
	}

	const [prefix = '', suffix = ''] = template.split('{{name}}');
	if (message.startsWith(prefix) && message.endsWith(suffix)) {
		return { isMe: false, name: message.slice(prefix.length, message.length - suffix.length) };
	}

	return undefined;
}

export function matchAgentChatSuggestions(
	messages: string[],
	t: TFunction,
): MatchedAgentChatSuggestion[] {
	return AGENT_CHAT_SUGGESTION_KEYS.flatMap((key) => {
		for (const message of messages) {
			const result =
				matchesTranslation(message, t(key)) ?? matchesTranslation(message, t(`${key}Me`));
			if (result) {
				return [{ key, ...result }];
			}
		}

		return [];
	});
}
